"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawerHeader = void 0;
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var Toolbar_1 = __importDefault(require("@mui/material/Toolbar"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var Divider_1 = __importDefault(require("@mui/material/Divider"));
var IconButton_1 = __importDefault(require("@mui/material/IconButton"));
var DrawerContext_1 = require("../DrawerContext");
var DrawerHeaderClasses_1 = __importStar(require("./DrawerHeaderClasses"));
var css_1 = require("@emotion/css");
var clsx_1 = __importDefault(require("clsx"));
var styles_1 = require("@mui/material/styles");
var Box_1 = __importDefault(require("@mui/material/Box"));
var base_1 = require("@mui/base");
var useUtilityClasses = function (ownerState) {
    var classes = ownerState.classes;
    var slots = {
        root: ['root'],
        background: ['background'],
        content: ['content'],
        navigation: ['navigation'],
        nonClickable: ['nonClickable'],
        nonClickableIcon: ['nonClickableIcon'],
        railIcon: ['railIcon'],
        subtitle: ['subtitle'],
        title: ['title'],
    };
    return (0, base_1.unstable_composeClasses)(slots, DrawerHeaderClasses_1.getDrawerHeaderUtilityClass, classes);
};
var Root = (0, styles_1.styled)(Toolbar_1.default, {
    shouldForwardProp: function (prop) { return !['backgroundColor', 'fontColor'].includes(prop.toString()); },
})(function (_a) {
    var _b, _c;
    var backgroundColor = _a.backgroundColor, fontColor = _a.fontColor, theme = _a.theme;
    return (_b = {
            width: '100%',
            alignItems: 'center',
            boxSizing: 'border-box',
            minHeight: "4rem"
        },
        _b[theme.breakpoints.down('sm')] = {
            minHeight: "3.5rem",
        },
        _b.backgroundColor = backgroundColor || (theme.palette.mode === 'dark' ? theme.palette.primary.dark : theme.palette.primary.main),
        _b.color = fontColor ||
            theme.palette.getContrastText(backgroundColor || (theme.palette.mode === 'dark' ? theme.palette.primary.dark : theme.palette.primary.main)),
        _b["& .".concat(DrawerHeaderClasses_1.default.nonClickable)] = {},
        _b["& .".concat(DrawerHeaderClasses_1.default.railIcon)] = (_c = {
                marginLeft: theme.spacing(0.5),
                minWidth: 'calc(3.5rem + 16px)',
                justifyContent: 'center'
            },
            _c["&.".concat(DrawerHeaderClasses_1.default.nonClickable)] = {
                marginLeft: 0,
            },
            _c),
        _b);
});
var Background = (0, styles_1.styled)(Box_1.default, {
    shouldForwardProp: function (prop) { return !['backgroundImage', 'backgroundOpacity'].includes(prop.toString()); },
})(function (_a) {
    var backgroundImage = _a.backgroundImage, backgroundOpacity = _a.backgroundOpacity;
    return ({
        position: 'absolute',
        zIndex: 0,
        width: '100%',
        backgroundSize: 'cover',
        height: '100%',
        backgroundPosition: 'center',
        backgroundImage: "url(".concat(backgroundImage, ")"),
        opacity: backgroundOpacity,
    });
});
var Navigation = (0, styles_1.styled)(Box_1.default, {})(function (_a) {
    var theme = _a.theme;
    return ({
        marginLeft: theme.spacing(2),
        minWidth: '2.5rem',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        zIndex: 1,
    });
});
var Content = (0, styles_1.styled)(Box_1.default, {})(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            marginLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
            minHeight: '4rem',
            display: 'flex',
            justifyContent: 'center',
            alignSelf: 'stretch',
            flexDirection: 'column',
            width: 'calc(100% - 2.5rem - 32px)',
            boxSizing: 'border-box',
            zIndex: 1
        },
        _b[theme.breakpoints.down('sm')] = {
            minHeight: "3.5rem",
        },
        _b);
});
var Title = (0, styles_1.styled)(Typography_1.default, {})(function () { return ({
    fontWeight: 600,
    lineHeight: '1.6rem', // Anything lower than 1.6rem cuts off bottom text of 'g' or 'y'.
}); });
var Subtitle = (0, styles_1.styled)(Typography_1.default, {})(function () { return ({
    lineHeight: '1.2rem',
    marginTop: '-0.125rem',
}); });
var NonClickableIcon = (0, styles_1.styled)(Box_1.default, {})(function () { return ({
    display: 'flex',
    padding: 0,
}); });
var DrawerHeaderRender = function (props, ref) {
    var _a;
    var defaultClasses = useUtilityClasses(props);
    var backgroundImage = props.backgroundImage, classes = props.classes, divider = props.divider, icon = props.icon, onIconClick = props.onIconClick, subtitle = props.subtitle, title = props.title, titleContent = props.titleContent, 
    // ignore unused vars so that we can do prop transferring to the root element
    /* eslint-disable @typescript-eslint/no-unused-vars */
    backgroundColor = props.backgroundColor, backgroundOpacity = props.backgroundOpacity, fontColor = props.fontColor, _b = props.disableGutters, disableGutters = _b === void 0 ? true : _b, sx = props.sx, 
    /* eslint-enable @typescript-eslint/no-unused-vars */
    otherToolbarProps = __rest(props, ["backgroundImage", "classes", "divider", "icon", "onIconClick", "subtitle", "title", "titleContent", "backgroundColor", "backgroundOpacity", "fontColor", "disableGutters", "sx"]);
    var _c = (0, DrawerContext_1.useDrawerContext)(), _d = _c.variant, variant = _d === void 0 ? 'persistent' : _d, _e = _c.condensed, condensed = _e === void 0 ? false : _e;
    var getHeaderContent = (0, react_1.useCallback)(function () {
        return titleContent || (react_1.default.createElement(Content, { className: (0, css_1.cx)(defaultClasses.content, classes.content) },
            react_1.default.createElement(Title, { noWrap: true, variant: 'h6', className: (0, css_1.cx)(defaultClasses.title, classes.title), "data-testid": 'blui-drawer-header-title' }, title),
            subtitle && (react_1.default.createElement(Subtitle, { noWrap: true, variant: 'body2', className: (0, css_1.cx)(defaultClasses.subtitle, classes.subtitle), "data-testid": 'blui-drawer-header-subtitle' }, subtitle))));
    }, [defaultClasses, classes, title, subtitle, titleContent]);
    var getBackgroundImage = (0, react_1.useCallback)(function () {
        return backgroundImage ? (react_1.default.createElement(Background, { className: (0, css_1.cx)(defaultClasses.background, classes.background), backgroundImage: backgroundImage, backgroundOpacity: backgroundOpacity })) : null;
    }, [backgroundImage, defaultClasses, classes]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Root, __assign({ ref: ref, "data-testid": 'blui-drawer-header', className: (0, css_1.cx)(defaultClasses.root, classes.root), backgroundColor: backgroundColor, fontColor: fontColor, disableGutters: disableGutters, sx: sx }, otherToolbarProps),
            getBackgroundImage(),
            icon && (react_1.default.createElement(Navigation, { className: (0, clsx_1.default)(defaultClasses.navigation, classes.navigation, (_a = {},
                    _a[defaultClasses.railIcon] = variant === 'rail' && !condensed,
                    _a[classes.railIcon] = variant === 'rail' && !condensed && classes.railIcon,
                    _a[defaultClasses.nonClickable] = variant === 'rail' && !condensed && !onIconClick,
                    _a)) },
                onIconClick && (react_1.default.createElement(IconButton_1.default, { color: 'inherit', onClick: function () {
                        onIconClick();
                    }, edge: 'start', size: 'large' }, icon)),
                !onIconClick && (react_1.default.createElement(NonClickableIcon, { className: (0, css_1.cx)(defaultClasses.nonClickableIcon, classes.nonClickableIcon) }, icon)))),
            getHeaderContent()),
        divider && react_1.default.createElement(Divider_1.default, null)));
};
/**
 * [DrawerHeader](https://brightlayer-ui-components.github.io/react/components/drawer-header) component
 *
 * The `<DrawerHeader>` contains the content at the top of the `<Drawer>`. By default, it renders multiple lines of text in the Brightlayer UI style. If you supply a `titleContent`, you can render your own custom content in the title area.
 */
exports.DrawerHeader = react_1.default.forwardRef(DrawerHeaderRender);
exports.DrawerHeader.displayName = 'DrawerHeader';
exports.DrawerHeader.defaultProps = {
    backgroundOpacity: 0.3,
    classes: {},
    divider: false,
};
exports.DrawerHeader.propTypes = {
    backgroundColor: prop_types_1.default.string,
    backgroundImage: prop_types_1.default.string,
    backgroundOpacity: prop_types_1.default.number,
    classes: prop_types_1.default.shape({
        root: prop_types_1.default.string,
        background: prop_types_1.default.string,
        content: prop_types_1.default.string,
        navigation: prop_types_1.default.string,
        nonClickableIcon: prop_types_1.default.string,
        railIcon: prop_types_1.default.string,
        subtitle: prop_types_1.default.string,
        title: prop_types_1.default.string,
    }),
    divider: prop_types_1.default.bool,
    fontColor: prop_types_1.default.string,
    icon: prop_types_1.default.element,
    onIconClick: prop_types_1.default.func,
    subtitle: prop_types_1.default.string,
    title: prop_types_1.default.string,
    titleContent: prop_types_1.default.element,
};
